import React from 'react';
import { useMsal } from '@azure/msal-react';

/**
 * LogoutButton component triggers Azure AD single logout.
 */
export const LogoutButton: React.FC = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    sessionStorage.clear();
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  return (
    <button
      onClick={handleLogout}
      aria-label="Sign out"
      className="btn-signout"
    >
      Sign out
    </button>
  );
};
